import {
    GET_INVENTORY_DATA,
    GET_INVENTORY_DATA_SUCCESS,
    GET_INVENTORY_DATA_FAILURE,
    SET_QUANTITY_VALIDATION,
    SET_INVENTORY_ITEMS_DETAILS,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    loading: false,
    totalRecords: 0,
    qtyValid: false,
    checkedItems: [],
};

const InventoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVENTORY_DATA:
            return {
                ...state,
                loading: true,
                totalRecords: 0,
            };
        case GET_INVENTORY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                inventoryData: action.payload.inventoryListDTO,
                totalResults: action.payload.itemsNumber,
                // totalSearcResults: action.payload.totalSearcResults
            };
        case GET_INVENTORY_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_INVENTORY_ITEMS_DETAILS:
            return {
                ...state,
                checkedItems: action.payload,
            };
        case SET_QUANTITY_VALIDATION:
            return {
                ...state,
                valid: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};
export default persistReducer(
    {
        key: 'inventoryKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    InventoryReducer
);
